:host {
  display: block;
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
}

.ls-status-item {
  padding-bottom: var(--ls-text-base);
  margin: 0;
}

.ls-status-item .label {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  margin: 0;
}

.ls-status-item .value {
  font-size: var(--ls-text-2xl);
  line-height: var(--ls-line-2xl);
  font-weight: 600;
  margin: 0;
}

.ls-status-item .timestamp {
  font-size: var(--ls-text-sm);
  line-height: var(--ls-line-sm);
  color: var(--ls-gray-600);
  margin: 0;
}
